import {SocialEntry} from "../../../types/SocialEntry";

let socials: SocialEntry[] = [
]

export default socials;